/* @ngInject */
const mySterilesForm = (
  toaster,
  $$sterile,
  valueHandler
) => {
  return {
    restrict: 'E',
    scope: {
      mySteriles: '=',
      enableValidator: '=',
    },
    template: require('./mySterilesForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.addSterile = () => {
        $scope.mySteriles.push($$sterile.new())
      }

      $scope.removeSterile = async (_index) => {
        const id = $scope.mySteriles[_index].id
        if (valueHandler.isId(id)) {
          try {
            const message = await $$sterile.request.delete(id)
            toaster.message(message)
            $scope.mySteriles.splice(_index, 1)
          } catch (error) {
            toaster.error(error)
          }
        } else {
          $scope.mySteriles.splice(_index, 1)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default mySterilesForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/directives/forms/mySterilesForm.js